// import React from "react";
import toast from "react-hot-toast";

export const NotificationToast = (title: string, body: string) => {
  toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? "animate-enter" : "animate-leave"
        } max-w-md w-full bg-white shadow-lg rounded-2xl pointer-events-auto flex ring-1 ring-black/5 p-4 border-l-4 border-primary`}
      >
        <div className="flex-1 w-0">
          <div className="flex items-start">
            <div className="ml-1 flex-1">
              <p className="text-sm font-bold text-slate-800 leading-tight">
                {title}
              </p>
              <p className="mt-1 text-xs text-slate-500 leading-relaxed">
                {body}
              </p>
            </div>
          </div>
        </div>
        <div className="ml-4 flex shrink-0">
          <button
            onClick={() => toast.dismiss(t.id)}
            className="text-slate-400 hover:text-slate-600 focus:outline-none transition-colors"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "14px",
              padding: "2px",
              alignSelf: "flex-start",
            }}
          >
            ✕
          </button>
        </div>
      </div>
    ),
    {
      position: "top-right",
      duration: 6000,
    }
  );
};
